import React, { useEffect, useState } from "react";

import { flattenedChildren } from "@kikoff/client-utils/src/react";
import { PageControllerV1 } from "@kikoff/hooks/src/usePageController";

import PageViewLayout from "@component/dashboard/offer/page_view_layout";

import { LayoutRegistration } from "../hooks/usePageFlow";

interface NamespaceProps extends LayoutRegistration {
  dataDependency?(): any;
  onRouteChange?(
    route: { path: string; params: Record<string, string> },
    context: { pageController: PageControllerV1 }
  ): void;
  children?: React.ReactNode;
  validate?(context: { params: Record<string, string> }): boolean;
}

export function Namespace({
  layout,
  dataDependency,
  onRouteChange,
  children,
  validate,
}: NamespaceProps) {
  const [shouldRender, setShouldRender] = useState(
    !dataDependency && !validate
  );

  useEffect(() => {
    if (dataDependency) {
      Promise.resolve(dataDependency()).then(() => {
        setShouldRender(true);
      });
    }
  }, []);

  useEffect(() => {
    if (validate?.({ params: layout.route?.params ?? {} })) {
      setShouldRender(true);
    }
  }, []);

  useEffect(() => {
    if (layout.route)
      onRouteChange?.(layout.route, { pageController: layout.pageController });
  }, [layout.route]);

  if (!shouldRender) return null;

  return (
    <PageViewLayout
      viewIndex={layout.localPages.index}
      views={flattenedChildren(children)}
    />
  );
}
